<template>
  <svg
    v-if="type === 'default'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="12"
      cy="12"
      r="12"
      :fill="fill"/>
    <path
      d="M18.354 8.85378L10.354 16.8538C10.3076 16.9003 10.2524 16.9372 10.1917 16.9623C10.131 16.9875 10.066 17.0004 10.0003 17.0004C9.93457 17.0004 9.86951 16.9875 9.80881 16.9623C9.74811 16.9372 9.69296 16.9003 9.64653 16.8538L6.14653 13.3538C6.05271 13.26 6 13.1327 6 13C6 12.8674 6.05271 12.7401 6.14653 12.6463C6.24035 12.5525 6.3676 12.4998 6.50028 12.4998C6.63296 12.4998 6.76021 12.5525 6.85403 12.6463L10.0003 15.7932L17.6465 8.14628C17.7403 8.05246 17.8676 7.99976 18.0003 7.99976C18.133 7.99976 18.2602 8.05246 18.354 8.14628C18.4479 8.2401 18.5006 8.36735 18.5006 8.50003C18.5006 8.63272 18.4479 8.75996 18.354 8.85378Z"
      :fill="iconColor"
      :stroke="iconColor"/>
  </svg>

  <svg
    v-else-if="type === 'outline'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2806 9.21937C16.3504 9.28903 16.4057 9.37175 16.4434 9.46279C16.4812 9.55384 16.5006 9.65144 16.5006 9.75C16.5006 9.84856 16.4812 9.94616 16.4434 10.0372C16.4057 10.1283 16.3504 10.211 16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.289 9.14964 15.3718 9.09432 15.4628 9.05658C15.5538 9.01884 15.6514 8.99941 15.75 8.99941C15.8486 8.99941 15.9462 9.01884 16.0372 9.05658C16.1283 9.09432 16.211 9.14964 16.2806 9.21937ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7661 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"
      :fill="fill" 
    />
  </svg>

</template>

<script setup>
defineOptions({
  name: 'V2IconsCheckCircle'
})

defineProps({
  type: {
    type: String,
    default: 'default',
    validator: value => ['default', 'outline'].includes(value)
  },
  fill: {
    type: String,
    default: '#671CC2'
  },
  iconColor: {
    type: String,
    default: colorLookup('surface.default', 'semantic')
  }
})
</script>
